import { Brand, Context, Data, Effect, Either, Layer, Array, Record, flow, } from 'effect';
import * as Art from './article';
import * as CS from './configurationSet';
const FBrand = Brand.nominal();
const FCase = Data.case();
export const Furniture = flow(FCase, FBrand);
export const tenant = (f) => f.configurationSet.tenant;
export class MissingProductIdForPartError {
    partId;
    _tag = 'Fixtuur/Aspect/Furniture/MissingProductIdForPartError';
    constructor(partId) {
        this.partId = partId;
    }
}
export class MissingAttachementsError {
    configurationSet;
    originalError;
    _tag = 'Fixtuur/Aspect/Furniture/MissingAttachementsError';
    constructor(configurationSet, originalError) {
        this.configurationSet = configurationSet;
        this.originalError = originalError;
    }
}
export class MissingHandednessError {
    configurationSet;
    _tag = 'Fixtuur/Aspect/Furniture/MissingHandednessError';
    constructor(configurationSet) {
        this.configurationSet = configurationSet;
    }
}
export const fromConfigurationSet = (configSet) => 
// TODO: refactor
Object.entries(configSet.parts)
    .reduce((selections, [_, part]) => {
    const articleId = part.productType;
    return Array.head(part.productIds).pipe(Either.fromOption(() => new MissingProductIdForPartError(articleId)), Either.map(productId => Art.fromProductId(productId, articleId)), Either.flatMap(article => selections.pipe(Either.map(Record.set(articleId, article)))));
}, Either.right({}))
    .pipe(Effect.flatMap(selections => Effect.gen(function* (_) {
    const possibleHandedness = yield* _(CS.possibleHandedness(configSet).pipe(Effect.mapError(e => new MissingAttachementsError(configSet, e))));
    const defaultHandedness = possibleHandedness.values().next();
    if (defaultHandedness.done) {
        return yield* _(Effect.fail(new MissingHandednessError(configSet)));
    }
    return Furniture({
        configurationSet: configSet,
        selections,
        handedness: defaultHandedness.value,
    });
})), x => x);
export const articleForPart = (furniture, articleId) => furniture.selections[articleId];
export const changeSelection = (furniture, article) => {
    return Furniture({
        ...furniture,
        selections: { ...furniture.selections, [article.articleId]: article },
    });
};
export class InvalidHandednessError extends Data.TaggedError('Fixtuur/Aspect/Furniture/InvalidHandednessError') {
}
/** Changes handedness for the Furniture without checking all of the products in
 * the config set support it */
export const unsafeChangeHandedness = (furniture, handedness) => {
    return Furniture({ ...furniture, handedness });
};
export const changeHandedness = (furniture, handedness) => {
    return Effect.gen(function* (_) {
        const possible = yield* _(CS.possibleHandedness(furniture.configurationSet));
        if (!possible.has(handedness)) {
            return yield* _(Effect.fail(new InvalidHandednessError({
                possible,
                attachmentErrors: [],
                furniture,
                attemptedHandedness: handedness,
            })));
        }
        else {
            return unsafeChangeHandedness(furniture, handedness);
        }
    }).pipe(Effect.withRequestCaching(true));
};
export class FixtuurAspectFurnitureService extends Context.Tag('@fixtuur/backpack/FixtuurAspectFurnitureService')() {
}
export const LiveFixtuurAspectFurnitureLayer = Layer.effect(FixtuurAspectFurnitureService, Effect.gen(function* (_) {
    const configSetService = yield* _(CS.FixtuurAspectConfigurationSetService);
    const changeHandedness = (furniture, handedness) => configSetService.possibleHandedness(furniture.configurationSet).pipe(Effect.flatMap(([err, possible]) => {
        if (!possible.has(handedness)) {
            return Effect.fail(new InvalidHandednessError({
                possible,
                attachmentErrors: err,
                furniture,
                attemptedHandedness: handedness,
            }));
        }
        else {
            return Effect.succeed(unsafeChangeHandedness(furniture, handedness));
        }
    }));
    return { changeHandedness };
})).pipe(Layer.provide(CS.LiveFixtuurAspectConfigurationSetService));
